export default {
  create: function create(win, url) {
    new win.Image().src = url;
  }
};